import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

// Components
import { NotificationsComponent } from './notifications.component';
import { NotificationItemComponent } from './components/notification-item/notification-item.component';
import { NotificationsHeaderComponent } from './components/notifications-header/notifications-header.component';

@NgModule({
  declarations: [
    NotificationsComponent,
    NotificationItemComponent,
    NotificationsHeaderComponent
  ],
  imports: [
    CommonModule,
    TranslateModule
  ],
  exports: [
    NotificationsComponent
  ]
})
export class NotificationsModule { }